'use client';

import React from 'react';
import useMediaQuery from '@/hooks/useMediaQuery';
import { Member } from '@/actions/byMember/getMember';

interface DevMemberProps {
  apiUrl: string | undefined;
  member: Member | null;
}

export default function DevMember({ apiUrl, member }: DevMemberProps) {
  const { matches: isMobile } = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: '110px', // 左右UI寬度
        right: '210px', // 左右UI寬度
        display: 'flex',
        justifyContent: 'center',
        zIndex: 999,
        opacity: 0.4,
        // pointerEvents: 'none', // 這個會讓scroll無效
        whiteSpace: 'pre',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: 50, // scroll
          overflowY: 'auto', // scroll
          // scrollbarWidth: 'thin',
          paddingLeft: 8,
          paddingRight: 8,
        }}
      >
        <div>API Server: {apiUrl?.split('/')[2]}</div>
        {!member ? (
          <div>MEMBER: 尚未登入</div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: 'center',
            }}
          >
            <div>MEMBER: {member.phone}</div>
            {isMobile ? null : <Separator />}
            <div>{member.email}</div>
            {isMobile ? null : <Separator />}
            <div>fullname: {member.fullname}</div>
            {isMobile ? null : <Separator />}
            <div>payment_method: {member.payment_method}</div>
            {isMobile ? null : <Separator />}
            <div>invoice_type: {member.invoice.type}</div>
          </div>
        )}
      </div>
    </div>
  );
}

function Separator() {
  return <div style={{ paddingLeft: 4, paddingRight: 4 }}>/</div>;
}
